
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"9","y":"15","width":"6","height":"13","rx":"3"}}),_c('rect',{attrs:{"y":"22","width":"6","height":"6","rx":"3"}}),_c('rect',{attrs:{"x":"18","y":"6","width":"6","height":"22","rx":"3"}}),_c('rect',{attrs:{"x":"27","width":"6","height":"28","rx":"3"}})])
          )
        }
      }
    